<template>
  <div class="container-fluid py-4 legal-page">
    <div class="card shadow-sm">
      <div class="card-body p-4 p-md-5">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <h3 class="mb-0">{{ currentTitle }}</h3>
          <div class="d-flex flex-wrap gap-2">
            <router-link
              class="btn btn-outline-primary btn-sm"
              :class="{ active: documentType === 'terminos' }"
              to="/legal/terminos"
            >
              Términos y condiciones
            </router-link>
            <router-link
              class="btn btn-outline-primary btn-sm"
              :class="{ active: documentType === 'privacidad' }"
              to="/legal/privacidad"
            >
              Política de privacidad
            </router-link>
          </div>
        </div>

        <p v-if="loading" class="text-muted mb-0">Cargando documento...</p>
        <p v-else-if="error" class="text-danger mb-0">{{ error }}</p>
        <article v-else class="legal-content">{{ currentContent }}</article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalDocumentPage',
  props: {
    documentType: {
      type: String,
      default: 'terminos',
    },
  },
  data() {
    return {
      loading: true,
      error: '',
      fullText: '',
    };
  },
  computed: {
    currentTitle() {
      return this.documentType === 'privacidad'
        ? 'Política de privacidad'
        : 'Términos y condiciones';
    },
    termsText() {
      if (!this.fullText) return '';
      const sections = this.fullText.split(/\nII\.\s*Política de Privacidad/i);
      return sections[0]?.trim() || '';
    },
    privacyText() {
      if (!this.fullText) return '';
      const markerRegex = /\nII\.\s*Política de Privacidad/i;
      const markerMatch = this.fullText.match(markerRegex);
      if (!markerMatch) return '';
      const splitIndex = this.fullText.search(markerRegex);
      return this.fullText.slice(splitIndex + 1).trim();
    },
    currentContent() {
      return this.documentType === 'privacidad'
        ? this.privacyText
        : this.termsText;
    },
  },
  async mounted() {
    try {
      const response = await fetch('/legal/legal-tecdriver.txt');
      if (!response.ok) {
        throw new Error('No fue posible cargar los documentos legales.');
      }
      this.fullText = await response.text();
    } catch (error) {
      this.error = error.message || 'Error al cargar el contenido legal.';
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.legal-page .card {
  border: 1px solid #eef0f4;
}

.legal-content {
  white-space: pre-line;
  line-height: 1.65;
  color: #2f3640;
}
</style>
